module.exports = __webpack_public_path__ + "img/step1.9322fb5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/step1.svg
// module id = ./assets/assistant/step1.svg
// module chunks = 10